var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.922,
    height: 30.769,
    viewBox: "0 0 26.922 30.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7a30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0a13d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "siguria",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3774",
    "data-name": "Path 3774",
    d: "M14.461,0A7.715,7.715,0,0,0,6.769,7.692V9.615H2.923A1.817,1.817,0,0,0,1,11.538V28.846a1.817,1.817,0,0,0,1.923,1.923H26a1.817,1.817,0,0,0,1.923-1.923V11.538A1.817,1.817,0,0,0,26,9.615H22.153V7.692A7.715,7.715,0,0,0,14.461,0Zm1.923,22.5V25H12.538V22.5a3.722,3.722,0,0,1-1.923-3.269,3.846,3.846,0,1,1,7.692,0A3.722,3.722,0,0,1,16.384,22.5ZM18.307,9.615H10.615V7.692a3.846,3.846,0,0,1,7.692,0Z",
    fill: "url(#linear-gradient)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.1612bb9cc374b64551ee728c6a863250.svg";
export { ForwardRef as ReactComponent };